import {put, takeEvery, select, delay} from 'redux-saga/effects';
import {checkPaymentStatus, getOrder, sendOrder} from 'new-actions/api.actions.ts';
import {getAssembledOrder} from 'helpers/purchase.helper.ts';
import {
	getCurrentDeliveryAddressSelector,
	getCurrentMenuSelector,
	getCurrentOrderLinesSelector,
	getCurrentPaymentTypeSelector,
	getCurrentPurchaseSelector,
	getCurrentRestaurantSelector, getCurrentSubPaymentTypeSelector,
	getCurrentTableNumberSelector, getTipAmountSelector,
} from '../selectors';
import {STRIPE_SUCCESS, VIPPS_SUCCESS} from 'new-constants/payment.constants';
import {CHECK_PAYMENT_STATUS_SUCCESS} from 'new-constants/api.constants';
import {PaymentStatuses} from 'new-constants/common.constants';
import {DONE_CARD_PAYMENT_WARNING_MESSAGE, DONE_PICKUP_WARNING_MESSAGE} from 'new-constants/popup.constants';
import {PLACE_ORDER} from 'new-constants/purchase.constants';
import {DONE_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE} from "../constants/popup.constants";
import {CHECK_ADYEN_PAYMENT_SUCCESS} from "../constants/api.constants";
import {checkSwishAdyenPayment} from "../actions/api.actions";

function* assembleAndSendOrder() {
	const state = yield select();
	
	const currentRestaurant = getCurrentRestaurantSelector(state);
	const currentOrderLines = getCurrentOrderLinesSelector(state);
	const currentPurchase = getCurrentPurchaseSelector(state);
	const currentPaymentType = getCurrentPaymentTypeSelector(state);
	const currentMenu = getCurrentMenuSelector(state);
	const currentTableNumber = getCurrentTableNumberSelector(state);
	const currentSubPaymentType = getCurrentSubPaymentTypeSelector(state);
	
	//TODO pass password
	yield put(
		sendOrder(
			getAssembledOrder(
				currentOrderLines,
				currentPurchase,
				currentRestaurant,
				state.orderTime,
				state.orderingMode,
				currentPaymentType,
				currentSubPaymentType?.id,
				getCurrentDeliveryAddressSelector(state),
				currentMenu,
				currentTableNumber,
				state.purchaseToken,
				getTipAmountSelector(state)
			)
		)
	);
}

function* sendCheckPaymentStatus(action) {
	yield put(checkPaymentStatus(action.orderId));
}

function* sendDelayedCheckPaymentStatus(action) {
	yield delay(7000);
	yield put(checkPaymentStatus(action.payload.orderId));
}

function* sendDelayedSwishCheckPaymentStatus(action) {
	yield delay(7000);
	yield put(checkSwishAdyenPayment(null, true, action.payload.orderId));
}

function* refetchOrder(action) {
	yield put(getOrder(action.payload.orderId));
}

export const purchaseSaga = function* orderLineSaga() {
	yield takeEvery(
		[
			action => action.type === PLACE_ORDER && !action.showPopup,
			DONE_PICKUP_WARNING_MESSAGE,
			DONE_CARD_PAYMENT_WARNING_MESSAGE,
			DONE_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE,
		],
		assembleAndSendOrder
	);
	
	yield takeEvery([STRIPE_SUCCESS, VIPPS_SUCCESS], sendCheckPaymentStatus);
	
	yield takeEvery(
		action => action.type === CHECK_PAYMENT_STATUS_SUCCESS && action.payload.data.status === PaymentStatuses.pending,
		sendDelayedCheckPaymentStatus
	);
	
	yield takeEvery(
		action => action.type === CHECK_ADYEN_PAYMENT_SUCCESS && action.payload.data.resultCode === PaymentStatuses.adyenPending,
		sendDelayedSwishCheckPaymentStatus
	);
	
	yield takeEvery(
		action => action.type === CHECK_PAYMENT_STATUS_SUCCESS && action.payload.data.status !== PaymentStatuses.pending,
		refetchOrder
	);
};
